
import { Vue, Options } from "vue-class-component";

@Options({
  props: {
    origin: {
      type: String,
      required: true,
    },
    originName: {
      type: String,
      required: true,
    },
    destination: {
      type: String,
      required: true,
    },
    destinationName: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasDangerousGoods: {
      type: Boolean,
      default: false,
    },
    hasQuarantine: {
      type: Boolean,
      default: false,
    },
    totalKoli: {
      type: Number,
      default: 0,
    },
    grossWeight: {
      type: Number,
      default: 0,
    },
    volumeWeight: {
      type: Number,
      default: 0,
    },
  },
})

@Options({})  
export default class CargoV2SearchFlightHeader extends Vue {
  title!: string;
  customClass!: string;
  isLoading!: boolean;

}
